import { render, staticRenderFns } from "./InjectAppBar.vue?vue&type=template&id=08b5122d&scoped=true"
import script from "./InjectAppBar.vue?vue&type=script&lang=js"
export * from "./InjectAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b5122d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b5122d')) {
      api.createRecord('08b5122d', component.options)
    } else {
      api.reload('08b5122d', component.options)
    }
    module.hot.accept("./InjectAppBar.vue?vue&type=template&id=08b5122d&scoped=true", function () {
      api.rerender('08b5122d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/vertical/InjectAppBar.vue"
export default component.exports